const Customer = {

    // FIELDS
    "personal_information": "معلومات شخصية",
    "customer_name": "اسم العميل",
    "customer_category": "فئة العميل",
    "short_name": "الاسم المختصر",
    "grade": "الدرجة",

    "contact_information": "معلومات الاتصال",
    "customer_type": "نوع العميل",
    "postal_code": "الرمز البريدي",
    "city": "المدينة",
    "po_box": "صندوق بريد",
    "website": "الموقع الإلكتروني",
    "fax": "الفاكس",
    "office_no": "رقم الاتصال بالمكتب",
    "address": "العنوان",
    "status": "الحالة",

    "rebate": "الخصم/التخفيض",
    "slab": "شريحة",
    "from_amount": "من المبلغ",
    "to_amount": "إلى المبلغ",
    "discount": "تخفيض ٪",

    "person_information": "معلومات الشخص",
    "person_name": "اسم الشخص",
    "designation": "التعيين",
    "department": "القسم",
    "mobile": "الجوال",
    "email": "البريد الإلكتروني",

    "general_information": "معلومات عامة",
    "tax_type": "نوع الضريبة",
    "currency": "العملة",
    "customer_group": "مجموعة العملاء",
    "black_listed": "قائمة السوداء",
    "region": "المنطقة",
    "vat_no": "رقم الضريبة على القيمة المضافة",
    "pan_no": "رقم البطاقة الشخصية",
    "registration_no": "رقم التسجيل",
    "credit_days": "أيام الائتمان",
    "credit_limit": "الحد الائتماني",
    "search_location": "ابحث عن الموقع",
    "lat": "خط العرض",
    "lng": "خط الطول",

    "dispatch_information": "تفاصيل شحن العميل",
    "same_check": "نفس عنوان العميل",
    "name": "الاسم",
    "gst_no": "رقم ضريبة السلع والخدمات",
    "priority": "الأولوية",
    "search": "بحث",

    // PAGE HEADER
    "customer": "العميل",

    // TOOLTIP
    "active": "تنشيط",
    "de_active": "إلغاء التنشيط",

    // SWEET ALERT
    "active_confirm_text": "هل أنت متأكد أنك تريد تنشيط العميل؟",
    "deactive_confirm_text": "هل أنت متأكد أنك تريد إلغاء تنشيط العميل؟",
    "status_text": "تم تغيير الحالة بنجاح",

    // ERROR
    "error_customer_name": "يرجى إدخال اسم العميل",
    "error_short_name": "يرجى إدخال الاسم المختصر",
    "error_customer_category": "يرجى تحديد فئة العميل",
    "error_grade": "يرجى تحديد الدرجة",
    "error_customer_type": "يرجى تحديد نوع العميل",
    "error_postal_code": "أدخل الرمز البريدي",
    "error_city": "يرجى تحديد المدينة",
    "error_po_box": "يرجى إدخال رقم صندوق البريد",
    "error_website": "يرجى إدخال رابط الموقع الإلكتروني",
    "error_fax": "يرجى إدخال رقم الفاكس",
    "error_office_no": "يرجى إدخال رقم الاتصال بالمكتب",
    "error_address": "يرجى إدخال العنوان",
    "error_status": "يرجى تحديد الحالة",
    "error_person_name": "يرجى إدخال الاسم",
    "error_designation": "يرجى إدخال التعيين",
    "error_department": "يرجى تحديد القسم",
    "error_mobile": "يرجى إدخال رقم الجوال",
    "error_email": "يرجى إدخال البريد الإلكتروني",
    "error_tax_type": "يرجى تحديد نوع الضريبة",
    "error_currency": "يرجى تحديد العملة",
    "error_customer_group": "يرجى تحديد مجموعة العملاء",
    "error_black_listed": "يرجى تحديد إذا كان في القائمة السوداء أم لا",
    "error_region": "يرجى تحديد المنطقة",
    "error_vat_no": "يرجى إدخال رقم ضريبة القيمة المضافة",
    "error_pan_no": "يرجى إدخال رقم البطاقة الشخصية",
    "error_register_no": "أدخل رقم التسجيل",
    "error_credit_days": "يرجى إدخال أيام الائتمان",
    "error_credit_limit": "يرجى إدخال الحد الائتماني",
    "error_lat": "يرجى إدخال خط العرض",
    "error_lng": "يرجى إدخال خط الطول",
    "error_tax_no": "أدخل الرقم الضريبي",
    "error_priority": "يرجى إدخال الأولوية",
    "error_type_error": "يرجى إدخال أرقام فقط",
    "error_from_amt": "أدخل المبلغ الابتدائي",
    "error_to_amt": "أدخل المبلغ النهائي",
    "error_discount": "أدخل نسبة الخصم",
    "error_greater_from": "يجب أن يكون أكبر من المبلغ الابتدائي",
    "error_negative": "لا يمكن أن يكون سالبًا",
    "error_greater": "لا يمكن أن يكون أكبر من 100",

    // TABLE HEADER
    "table_name": 'الاسم',
    "table_grade": 'الدرجة',
    "table_type": "النوع",
    "table_city": "المدينة",
    "table_customer_cat": "فئة العميل",
    "table_status": "الحالة",

    // DETAILS
    "contact_no": "رقم الاتصال",
    "category": "الفئة",
    "type": "النوع",
    "vat_no_dtl": "رقم ضريبة القيمة المضافة",
    "pan_no_dtl": "رقم البطاقة الضريبية",
    "registration_no_dtl": "رقم التسجيل",
    "sales": "المبيعات",
    "payment": "الدفع",
    "total_order": "إجمالي الطلبات",
    "pending_order": "الطلبات المعلقة",

    // DETAILS TAB
    "orders": "الطلبات",
    "dispatch_address": "عنوان الشحن",
    "name": "الاسم",
    "tax_no": "الرقم الضريبي (ضريبة القيمة المضافة/الضريبة على السلع والخدمات)",
    "order_id": "رقم الطلب",
    "payment_id": "معرف الدفع",
    "amount": "المبلغ",
    "date": "التاريخ"

}

export default Customer;